<template>
  <div class="Login" style="margin-bottom: 50px; width: 100%; text-align:center;">
    <img src="../assets/judyslogo.png" width="400px;" style="margin-top: 50px; margin-bottom: 2px; text-align: center" alt="">
    <h1 style=" text-align: center">Alteration Management System</h1>
    <h2 style=" text-align: center">Login</h2>
    <h3 style="margin-top: 15px; color: red;" v-if="this.lockedAccount">This account was locked after 3 unsuccessful attempts.</h3>
    <v-container v-if="this.loader">
      <v-progress-circular
        indeterminate
        color="primary"
      ></v-progress-circular>
    </v-container>
    <v-container v-else style="width: 100%; display: flex; flex-direction: row; justify-content: center;">
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
      >
        <v-row>
          <v-col cols=12>
            <v-text-field
              label="Username"
              type="text"
              :rules="usernameRules"
              required
              v-model="username"
            ></v-text-field>
          </v-col>
          <v-col cols=12>
            <v-text-field
              label="Password"
              type="password"
              :rules="passwordRules"
              required
              v-model="password"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols=12>
            <v-btn :disabled="!valid" color="success" @click="login">Login</v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-container>
    <p style="margin-top: 50px;">⚡ by <a href="https://varion.co">Varion</a></p>
    <dialog-snack ref="snackbar" :color="snackObj.color" :text="snackObj.text"/>
  </div>
</template>

<script>

import axios from 'axios';
// axios.defaults.withCredentials = true;
import {mapGetters, mapMutations} from "vuex";
export default {
  name: 'Login',
  components: {
  },
  data () {
    return {
      loader: false,
      snackObj: {
        color: '',
        text: ''
      },
      username: '',
      password: '',
      valid: false,
      usernameRules: [
        v => !!v || 'Username is required',
      ],
      passwordRules: [
        v => !!v || 'Password is required',
      ],
      lockedAccount:false
    }
  },
  mounted(){
    this.removeIds()
  },
  computed: {
    ...mapGetters(['getEndpoint', 'getId'])
  },
  methods: {
    ...mapMutations(['setUser', 'setToken', 'removeIds', 'setPerms', 'setUserCache', 'setGLOBALS', 'setLocations']),
    snack(text, color=""){
      this.snackObj.text = text;
      this.snackObj.color = color;

      this.$refs.snackbar.openDialog();
    },
    async login(){
      try {
        if(this.$refs.form.validate()){
          this.loader = true;
          let res = await axios.post(`${this.getEndpoint}/auth/login`, {username: this.username, password: this.password})
          if(res.data.success){
            this.setGLOBALS((await axios.get(`${this.getEndpoint}/api/globals`)).data.data)

            this.setUser(res.data.user)
            console.log("✅User data loaded.")
            this.setPerms(res.data.perms)
            console.log("✅User perms loaded.")

            let userNames = await axios.get(`${this.getEndpoint}/api/users/userNames`)
            if(userNames.data.success){
              this.setUserCache(userNames.data.data)
              console.log("✅ Users cache loaded.")
            }
            else throw "❌ Users cache not loaded. Please retry."

            let locations = await axios.get(`${this.getEndpoint}/api/locations`)
            if(locations.data){
              this.setLocations(locations.data)
              console.log("✅ Locations loaded.")
            }
            else throw "❌ Locations not loaded. Please retry."

            console.log('Moving on to next page', this.getId)
            await this.$router.push({path: "/"})
          }else if(res.data.error){
            throw res.data.error
          }
          else{
            this.snack("❌ Username or Password Incorrect", "error")
          }
        }
      } catch (error) {
        if(error.msg==="Account suspended after 3 unsuccessful login attempts.") this.lockedAccount = true
        console.error(error);
        this.snack(error.msg || error, "error");
      } finally {
        this.loader = false;
      }
    }
  }
}
</script>
